import { render } from "./App.vue?vue&type=template&id=5e019a2f"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/vue/App.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5e019a2f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5e019a2f', __exports__)) {
    api.reload('5e019a2f', __exports__)
  }
  
  module.hot.accept("./App.vue?vue&type=template&id=5e019a2f", () => {
    api.rerender('5e019a2f', render)
  })

}


export default __exports__